import React from 'react';

interface EmptyStateProps {
  message?: string;
  description?: string;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  message = 'No data available',
  description,
  icon
}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-[#1a1a1a]">
      <div className="text-center max-w-md px-6">
        {/* Icon or default */}
        {icon ? (
          <div className="mb-4">{icon}</div>
        ) : (
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-800/50 mb-4">
            <svg 
              className="w-10 h-10 text-gray-500" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" 
              />
            </svg>
          </div>
        )}

        <h2 className="text-xl font-semibold text-gray-400 mb-2">{message}</h2>
        
        {description && (
          <p className="text-gray-500 text-sm">{description}</p>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
